// extracted by mini-css-extract-plugin
export default {"wrapper":"menu-subheader-layout_wrapper__8pRQV"};